var _ = require("lodash");
var dd = require("react-dd");
var radio = require("react-pubsub-via-radio.js/radio");
var RadioMixin = require("react-pubsub-via-radio.js/RadioMixin");

(function(){
	//The purpose is to ensure only one modal at a time is rendered to the page, so they don't stack on top of each other

	//This is a way of queuing all modals that whish to be displayed
	var modals_queue = [];

	var update = function(new_shown_modals){
		modals_queue = new_shown_modals;
		radio("ESPModal_setVisible").broadcast(_.first(modals_queue));
	};

	radio("ESPModal_please_show_me").subscribe(function(modal_id){
		update(_.unique(modals_queue.concat([modal_id])));
	});
	radio("ESPModal_good_bye").subscribe(function(modal_id){
		update(_.without(modals_queue, modal_id));
	});
}());

module.exports = dd.createClass({
	mixins: [RadioMixin],
	getInitialState: function(){
		return {is_visible: false, my_modal_id: _.uniqueId("ESPModal")};
	},
	Radio_setup: function(){
		return {
			ESPModal_setVisible: function(modal_id){
				if(modal_id === this.state.my_modal_id){
					if(!this.state.is_visible){
						this.setState({is_visible: true});
					}
				}
			}
		};
	},
	componentDidMount: function(){
		radio("ESPModal_please_show_me").broadcast(this.state.my_modal_id);
	},
	componentWillUnmount: function(){
		radio("ESPModal_good_bye").broadcast(this.state.my_modal_id);
	},
	render: function(){
		if(!this.state.is_visible){
			return dd.span();
		}
		var title = this.props.title;
		var onClose = this.props.onClose;

		var buttons = [];
		if(_.isArray(this.props.buttons)){
			buttons = this.props.buttons;
		}else{
			if(_.isFunction(onClose)){
				buttons.push({name: 'Close', onClick: onClose, className: 'btn btn-default'});
			}
		}

		return dd.div(null,
			dd.div({className: 'modal fade in', tabIndex: -1, role: 'dialog', style: {display: 'block'}},
				dd.div({className: 'modal-dialog'},
					dd.div({className: 'modal-content'},
						!title ? null : dd.div({className: 'modal-header'},
							!_.isFunction(onClose) ? null : dd.button({type: 'button', className: 'close', onClick: onClose},
								'x'
							),
							dd.h4({className: 'modal-title'}, title),
							this.props.header
						),
						dd.div({className: 'modal-body'},
							this.props.children
						),
						buttons.length === 0 ? null : dd.div({className: 'modal-footer'},
							_.map(buttons, function(button, i){
								return dd.button({
										key: i,
										type: 'button',
										className: button.className,
										onClick: button.onClick
									},
									button.name
								);
							})
						)
					)
				)
			),
			dd.div({className: 'modal-backdrop fade in', onClick: !_.isFunction(onClose) ? null : onClose})
		);
	}
});



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/Modal.js
// module id = 10
// module chunks = 0 1 2 3 4